import { render, staticRenderFns } from "./DatingCityPage.vue?vue&type=template&id=160cd275&"
import script from "./DatingCityPage.vue?vue&type=script&lang=js&"
export * from "./DatingCityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports